import { QueryHookOptions, gql } from '@apollo/client'
import { usePersistedCacheQuery } from 'app/hooks'

const query = gql`
  query FetchArticleCategory($slug: String!) {
    ArticleCategories(where: { slug: { equals: $slug } }) {
      docs {
        id
        name
        slug
        meta {
          title
          description
        }
      }
    }
  }
`

export interface ArticleCategoryQueryInput {
  slug: string
}

export interface ArticleCategoryQueryOutput {
  ArticleCategories: {
    docs: {
      id: string
      name: string
      slug: string
      meta: {
        title?: string
        description?: string
      }
    }[]
  }
}

export const useArticleCategoryQuery = (input: ArticleCategoryQueryInput, options?: QueryHookOptions<ArticleCategoryQueryOutput, ArticleCategoryQueryInput>) =>
  usePersistedCacheQuery<ArticleCategoryQueryOutput, ArticleCategoryQueryInput>(query, { variables: input, ...options })

export const articleCategoryQuery = { query }
